<template>
   <svg :width="props.width" :height="props.height" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.7">
      <path
        d="M8.84006 2.39982L3.36673 8.19315C3.16006 8.41315 2.96006 8.84649 2.92006 9.14649L2.6734 11.3065C2.58673 12.0865 3.14673 12.6198 3.92006 12.4865L6.06673 12.1198C6.36673 12.0665 6.78673 11.8465 6.9934 11.6198L12.4667 5.82649C13.4134 4.82649 13.8401 3.68649 12.3667 2.29315C10.9001 0.913152 9.78673 1.39982 8.84006 2.39982Z"
        :stroke="props.color" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
        stroke-linejoin="round" />
      <path d="M7.92676 3.3667C8.21342 5.2067 9.70676 6.61337 11.5601 6.80003" :stroke="props.color"
        stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M2 14.6665H14" :stroke="props.color" stroke-width="1.5" stroke-miterlimit="10"
        stroke-linecap="round" stroke-linejoin="round" />
    </g>
  </svg>
</template>
<script setup>
import { defineProps } from 'vue';

const props = defineProps({
    color: {
        type: String,
        default: '#484848',
    },
    width: {
        type: Number,
        default: 16,
    },
    height: {
        type: Number,
        default: 16,
    },
});
</script>